import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";

@Component({
  selector: 'page-unit-history',
  templateUrl: 'unit-history.html'
})
export class UnitHistoryPage {

  unit:any;
  partsCount = 0;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public superTabsCtrl: SuperTabsController
  ) {
    this.unit = navParams.get('unit');
    this.updatePartsCount();
  }

  private updatePartsCount() {
    this.partsCount = 0;
    if (this.unit.reports && this.unit.reports.length > 0) {
      for(let report of this.unit.reports) {
        if (report.report_data && report.report_data.parts && report.report_data.parts.length) {
          this.partsCount += report.report_data.parts.length;
        }
        if (report.report_data && report.report_data.repairs && report.report_data.repairs.length) {
          this.partsCount += report.report_data.repairs.length;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/unit-history/unit-history.ts